import { useState } from 'react'
import { Button, Input, Popconfirm } from 'antd'
import { Guard } from 'src/features/session/guard'
import { submitModerationTask } from 'src/pages/worldCup2026/tasks/model'

type Props = {
  id: number
}

export const RejectButton = ({ id }: Props) => {
  const [reason, setReason] = useState('')
  const { TextArea } = Input
  return (
    <Guard permission="world_cup_2026_task_update">
      <Popconfirm
        title="Confirm reject task"
        description={
          <TextArea
            rows={4}
            autoFocus
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Enter reason"
            style={{ width: 350 }}
          />
        }
        okText="Yes"
        onOpenChange={(open) => {
          if (!open) {
            setReason('')
          }
        }}
        okButtonProps={{
          disabled: !Boolean(reason.trim()),
        }}
        onConfirm={() =>
          submitModerationTask({
            id: String(id),
            status: 'declined',
            declineReason: reason.trim(),
          })
        }
        cancelText="No"
      >
        <Button color="volcano" variant="solid">
          Reject
        </Button>
      </Popconfirm>
    </Guard>
  )
}
